(function () {
if (window.__evamatsProductFormJsLoaded) return;
window.__evamatsProductFormJsLoaded = true;

const DROP_CELL_SHAPE_VARIANT_ID = 51194860011798;

/* 2026-09-21 (владелец, «почему так долго»): раньше допы уходили ОТДЕЛЬНЫМ запросом, и он ждался перед
   основным — лишний круг в 0,8–1,2 с на каждом заказе с подпяткой, допом или формой ячеек «капли».
   Теперь всё уходит одним `/cart/add.js`: `items[]` = допы, затем комплект. Порядок прежний (допы раньше
   комплекта), поэтому корзина выглядит так же, как и до правки. */
const supplementalItemList = (ids) => {
  const quantities = ids.reduce((items, value) => {
    const id = Number(value);
    if (Number.isSafeInteger(id) && id > 0) items.set(id, (items.get(id) || 0) + 1);
    return items;
  }, new Map());
  return [...quantities].map(([id, quantity]) => ({ id, quantity }));
};

// Из формы конфигуратора берём ровно то, что понимает /cart/add.js: вариант, количество и свойства строки.
// Остальные поля формы (`form_type`, `utf8`, `product-id`, `section-id`, имена опций) API и так не читает —
// они нужны только пикеру вариантов на странице.
const formToCartItem = (form) => {
  const item = { quantity: 1, properties: {} };
  for (const [key, value] of new FormData(form).entries()) {
    if (key === 'id') item.id = Number(value);
    else if (key === 'quantity') item.quantity = Number(value) || 1;
    else if (key === 'selling_plan') item.selling_plan = Number(value);
    else {
      const property = key.match(/^properties\[(.+)\]$/);
      if (property) item.properties[property[1]] = String(value);
    }
  }
  return item;
};

// Адрес берём из routes (он несёт префикс языка), но обязательно с «.js»: без него Shopify отдаёт
// укороченную строку — в ней нет `image`, и подтверждение осталось бы без картинки товара.
const cartAddUrl = () => {
  const base = (window.routes && window.routes.cart_add_url) || '/cart/add';
  return /\.js$/.test(base) ? base : base + '.js';
};

const postCartItems = (items, extra) =>
  fetch(cartAddUrl(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify(Object.assign({ items }, extra || {})),
  }).then(async (response) => ({ ok: response.ok, status: response.status, data: await response.json().catch(() => ({})) }));

/* Подтверждение поверх страницы: показывается сразу после успешного ответа и остаётся видимым, пока
   браузер грузит /cart. Стили держим прямо здесь — на страницах аксессуаров CRO-таблица стилей не
   подключается, и внешний файл мог бы не приехать. Тексты берём из variantStrings (ключи
   general.cart.item_added и general.cart.view_empty_cart есть во всех пяти локалях). */
const OVERLAY_ID = 'evamats-atc-overlay';
const OVERLAY_CSS = `
#evamats-atc-overlay{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:24px;background:rgba(27,29,34,.55);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);animation:evamats-atc-in .18s ease-out both}
#evamats-atc-overlay .evamats-atc__card{width:100%;max-width:340px;box-sizing:border-box;padding:22px 20px 18px;border-radius:18px;background:#fff;box-shadow:0 18px 50px rgba(27,29,34,.28);text-align:center;color:#1b1d22}
#evamats-atc-overlay .evamats-atc__check{display:grid;place-items:center;width:52px;height:52px;margin:0 auto 12px;border-radius:50%;background:#ff2741;color:#fff}
#evamats-atc-overlay .evamats-atc__check svg{width:26px;height:26px}
#evamats-atc-overlay .evamats-atc__title{margin:0 0 10px;font-size:17px;font-weight:700;line-height:1.3;letter-spacing:-.02em}
#evamats-atc-overlay .evamats-atc__item{display:flex;align-items:center;gap:10px;margin:0 0 14px;text-align:left}
#evamats-atc-overlay .evamats-atc__thumb{flex:none;width:48px;height:48px;border-radius:10px;object-fit:cover;background:#f6f6f6}
#evamats-atc-overlay .evamats-atc__name{font-size:13px;line-height:1.35;color:#5b5f66}
#evamats-atc-overlay .evamats-atc__bar{position:relative;height:3px;margin:0 0 12px;overflow:hidden;border-radius:3px;background:rgba(27,29,34,.12)}
#evamats-atc-overlay .evamats-atc__bar span{position:absolute;top:0;bottom:0;left:0;width:40%;border-radius:inherit;background:#ff2741;animation:evamats-atc-run 1s linear infinite}
#evamats-atc-overlay .evamats-atc__link{display:inline-block;font-size:14px;font-weight:600;color:#ae1631;text-decoration:underline}
@keyframes evamats-atc-in{from{opacity:0}to{opacity:1}}
@keyframes evamats-atc-run{from{transform:translateX(-110%)}to{transform:translateX(300%)}}
@media (prefers-reduced-motion:reduce){
#evamats-atc-overlay{animation:none}
#evamats-atc-overlay .evamats-atc__bar span{animation:none;width:100%}
}`;

function showAddedOverlay(line) {
  if (document.getElementById(OVERLAY_ID)) return;
  if (!document.getElementById(OVERLAY_ID + '-css')) {
    const style = document.createElement('style');
    style.id = OVERLAY_ID + '-css';
    style.textContent = OVERLAY_CSS;
    document.head.appendChild(style);
  }
  const strings = window.variantStrings || {};
  const box = document.createElement('div');
  box.id = OVERLAY_ID;
  box.setAttribute('role', 'status');
  box.setAttribute('aria-live', 'polite');
  const image = line && line.image ? String(line.image).replace(/(\.[a-z]+)(\?|$)/i, '_96x$1$2') : '';
  const name = (line && (line.product_title || line.title)) || '';
  box.innerHTML = `
    <div class="evamats-atc__card">
      <span class="evamats-atc__check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
      <p class="evamats-atc__title"></p>
      <div class="evamats-atc__item">
        ${image ? '<img class="evamats-atc__thumb" src="' + image + '" alt="" width="48" height="48">' : ''}
        <span class="evamats-atc__name"></span>
      </div>
      <div class="evamats-atc__bar" aria-hidden="true"><span></span></div>
      <a class="evamats-atc__link" href="${(window.routes && window.routes.cart_url) || '/cart'}"></a>
    </div>`;
  box.querySelector('.evamats-atc__title').textContent = strings.itemAdded || '';
  box.querySelector('.evamats-atc__name').textContent = name;
  box.querySelector('.evamats-atc__link').textContent = strings.viewCart || '';
  document.body.appendChild(box);
}

function hideAddedOverlay() {
  const box = document.getElementById(OVERLAY_ID);
  if (box) box.remove();
}

// Возврат «назад» может восстановить страницу из кэша вместе с подтверждением — снимаем его.
window.addEventListener('pageshow', (event) => { if (event.persisted) hideAddedOverlay(); });

// Объявление кастомного элемента product-form
if (!customElements.get('product-form')) {
 
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.initializeElements();
      this.setupEventListeners();
    }

    initializeElements() {
      
      this.getContactsForm = document.querySelector('#popupOverlayGetContacts');
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[name="add"]') || this.querySelector('.product-form__submit');
      if (this.submitButton && this.cart && document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
      this.responseProduct = '';
      const showNotification = document.querySelector('.showNotification');
      if (!showNotification) return;
      showNotification.addEventListener('click', () => {
        this.cart.renderContents(this.responseProduct);
        this.getContactsForm.classList.remove('show');
        document.querySelector('html').classList.remove('overflow-hidden')
        setTimeout(() => { this.cart.querySelector('#cart-notification').classList.add('active'); }, 200);
        console.log(this.cart.querySelector('#cart-notification'))
      });
    }

    setupEventListeners() {
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    getStickyCartButtons() {
      return Array.from(document.querySelectorAll('.sticky_add_to_cart'));
    }

    isConfigCartButton(button) {
      return button?.matches('.evamats-config-checkout__cart, .evamats-config-step-bar__cart');
    }

    getCartButtonLabel(button) {
      return (
        button?.querySelector('[data-add-to-cart-label]') ||
        button?.querySelector('.evamats-config-checkout__cart-label')
      );
    }

    setLoadingState(isLoading) {
      const addingText = window.variantStrings?.addingToCart || '';
      const buttons = [this.submitButton, ...this.getStickyCartButtons()].filter(Boolean);

      buttons.forEach((button) => {
        const isConfigBtn = this.isConfigCartButton(button);
        const label = this.getCartButtonLabel(button);
        const icon = button.querySelector(':scope > svg');
        const spinner = button.querySelector('.loading-overlay__spinner');

        if (isLoading) {
          button.setAttribute('aria-disabled', 'true');
          button.setAttribute('aria-busy', 'true');

          if (isConfigBtn) {
            button.classList.add('is-adding-to-cart');
            button.classList.remove('loading');
          } else {
            button.classList.add('loading');
          }

          if (label && addingText) {
            if (!label.dataset.defaultLabel) {
              label.dataset.defaultLabel = label.textContent.trim();
            }
            label.textContent = addingText;
          }

          if (icon) icon.setAttribute('aria-hidden', 'true');
          if (spinner) spinner.classList.remove('hidden');
        } else {
          button.classList.remove('loading', 'is-adding-to-cart');
          button.removeAttribute('aria-busy');
          if (!this.error) button.removeAttribute('aria-disabled');

          if (label && label.dataset.defaultLabel) {
            label.textContent = label.dataset.defaultLabel;
          }

          if (icon) icon.removeAttribute('aria-hidden');
          if (spinner) spinner.classList.add('hidden');
        }
      });
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      const productScope = this.closest('[data-product-id]');
      const matPatternInputChecked = (productScope || this.form).querySelector('[data-type="matPattern"] input:checked');
      // EVA heel pads share the configurator, but only mat sets pay the drops surcharge.
      const isEvaHeelPad = productScope?.dataset.productId === '9257148317974';

      if (this.submitButton?.getAttribute("aria-disabled") === "true") return;

      if (this.handleErrorMessage() == false) {
        return;
      }

      this.error = false;
      this.setLoadingState(true);

      // Тело запроса собирается ниже одним `items[]` (комплект + допы), поэтому FormData больше не нужна;
      // от прежнего блока остаётся только запоминание активного элемента для ящика.
      if (this.cart) this.cart.setActiveElement(document.activeElement);

      const productUpsell = document.querySelector(".product__dropdown_wr--heel .product__upsell");
      const upsellItems = productUpsell
        ? productUpsell.querySelectorAll(".product__upsell_item")
        : [];

      try {
        const supplementalItems = [];
        if (productUpsell) {
          for (const item of upsellItems) {
            const input = item.querySelector("input[type='checkbox']");
            if (input && input.checked && input.value) supplementalItems.push(input.value);
          }
        }

        const extrasWr = document.querySelector(".product__dropdown_wr--extras");
        if (extrasWr) {
          const extrasChecked = extrasWr.querySelectorAll("input[name='product__extras']:checked");
          for (const input of extrasChecked) {
            if (input.value) supplementalItems.push(input.value);
          }
        }

        if (matPatternInputChecked && !isEvaHeelPad && matPatternInputChecked.getAttribute('data-value') == 'drop') {
          supplementalItems.push(DROP_CELL_SHAPE_VARIANT_ID);
        }

        const mainItem = formToCartItem(this.form);
        const supplements = supplementalItemList(supplementalItems);
        const extra = this.cart
          ? { sections: this.cart.getSectionsToRender().map((section) => section.id).join(','), sections_url: window.location.pathname }
          : null;

        let result = await postCartItems([...supplements, mainItem], extra);
        // Один запрос — значит, и отказ общий: недоступная подпятка утащила бы за собой весь комплект.
        // Поэтому при неудаче с допами повторяем без них — как было до слияния, когда допы были
        // необязательной частью.
        if (!result.ok && supplements.length) {
          console.warn('[product-form] добавление с допами не прошло, повторяем без них', result.data);
          result = await postCartItems([mainItem], extra);
        }
        const response = result.data;

        if (!result.ok || response.status) {
          this.handleErrorMessage(response.description);
          const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
          if (soldOutMessage) {
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.querySelector("span").classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
          }
          this.setLoadingState(false);
          return;
        }

        if (!this.cart) {
          // Ящика и уведомления в этой теме нет (settings.cart_type = page), поэтому дальше идёт полный
          // переход на /cart. Показываем подтверждение до перехода: старая страница остаётся на экране,
          // пока грузится корзина, и ожидание читается как «добавлено, открываю», а не как зависание.
          const cartUrl = window.routes?.cart_url || '/cart';
          const lines = Array.isArray(response.items) ? response.items : [response];
          const added = lines.find((line) => Number(line.id) === mainItem.id) || lines[0] || {};
          showAddedOverlay(added);
          requestAnimationFrame(() => requestAnimationFrame(() => { window.location.href = cartUrl; }));
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
        const quickAddModal = this.closest("quick-add-modal");
        if (quickAddModal) {
          document.body.addEventListener(
            "modalClosed",
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
          this.responseProduct = response;
        }

        setTimeout(() => this.setLoadingState(false), 600);
      } catch (e) {
        console.error(e);
        this.error = true;
        this.setLoadingState(false);
      } finally {
        if (this.cart && this.cart.classList.contains("is-empty")) {
          this.cart.classList.remove("is-empty");
        }
      }
    }

    handleErrorMessage() {
      let formValid = true;
      let firstInvalidElement = null;
    
      function validateRequiredGroups() {
        // Выбираем только обязательные поля, которые не находятся внутри опциональных шагов
        const requiredElements = Array.from(
          document.querySelectorAll('.product__info-container input[required], .product__info-container select[required]')
        ).filter(el => !el.closest('.product__dropdown_wr--hell'));
        
        const groups = new Map();
    
        requiredElements.forEach((element) => {
          const fieldset = element.closest('fieldset');
          if (fieldset) {
            if (!groups.has(fieldset)) {
              groups.set(fieldset, []);
            }
            groups.get(fieldset).push(element);
          }
        });
    
        groups.forEach((elements, fieldset) => {
          let groupValid = elements.some(element => {
            if (element.type === 'radio' || element.type === 'checkbox') {
              return element.checked;
            } else if (element.type === 'select-one') {
              return element.value;
            } else if (element.type === 'text') {
              return element.value.trim() !== '';
            }
            return false;
          });
    
          const errorMessage = fieldset.querySelector('.error-message');
          if (!groupValid) {
            if (errorMessage) {
              errorMessage.style.display = 'block';
            }
            formValid = false;
            if (!firstInvalidElement) {
              firstInvalidElement = fieldset;
            }
          } else {
            if (errorMessage) {
              errorMessage.style.display = 'none';
            }
          }
        });
      }
    
      validateRequiredGroups();
    
      // Проверяем обязательные шаги: пропускаем шаги, которые находятся внутри опциональных контейнеров
      const steps = Array.from(
        document.querySelectorAll('product-info .product__dropdown_inner')
      ).filter(step => !step.closest('.product__dropdown_wr--heel'));
    
      steps.forEach(step => {
        if (!step.classList.contains('super_done')) {
          // Если шаг не завершён, отмечаем форму как невалидную
          formValid = false;
          if (!firstInvalidElement) {
            firstInvalidElement = step.closest('.product__dropdown_wr');
          }
        }
      });
    
      if (!formValid) {
        if (firstInvalidElement) {
          console.log(firstInvalidElement)
          const offsetTop = firstInvalidElement.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }
        // Убираем или комментируем вывод ошибки в консоль, чтобы не мешало
        console.log('Form is not valid');
        return false;
      } else {
        console.log('Form is valid');
        return true;
      }
    }
    
    
  });
}

function resetAddToCartButtonState(button) {
  const label =
    button.querySelector('[data-add-to-cart-label]') ||
    button.querySelector('.evamats-config-checkout__cart-label');
  const addingText = (window.variantStrings?.addingToCart || '').trim();
  const defaultText = (label?.dataset.defaultLabel || window.variantStrings?.addToCart || '').trim();

  button.classList.remove('loading', 'is-adding-to-cart');
  button.removeAttribute('aria-busy');
  if (!button.disabled) button.removeAttribute('aria-disabled');

  if (label && defaultText) {
    const current = label.textContent.trim();
    if (!label.dataset.defaultLabel && current && current !== addingText) {
      label.dataset.defaultLabel = current;
    }
    if (!addingText || current === addingText) {
      label.textContent = defaultText;
    }
  }

  const icon = button.querySelector(':scope > svg');
  if (icon) icon.removeAttribute('aria-hidden');

  const spinner = button.querySelector('.loading-overlay__spinner');
  if (spinner) spinner.classList.add('hidden');
}

function resetStuckAddToCartButtons() {
  const selectors = [
    '.evamats-config-checkout__cart',
    '.evamats-config-step-bar__cart',
    '.sticky_add_to_cart',
    'product-form .product-form__submit',
  ];

  document.querySelectorAll(selectors.join(', ')).forEach((button) => {
    const label =
      button.querySelector('[data-add-to-cart-label]') ||
      button.querySelector('.evamats-config-checkout__cart-label');
    const addingText = (window.variantStrings?.addingToCart || '').trim();
    const isStuck =
      button.classList.contains('is-adding-to-cart') ||
      button.classList.contains('loading') ||
      button.getAttribute('aria-busy') === 'true' ||
      (label && addingText && label.textContent.trim() === addingText);

    if (isStuck) resetAddToCartButtonState(button);
  });
}

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    resetStuckAddToCartButtons();
  }
});

// Логика для кнопки "Купить сейчас"
// const buyNowButton = document.getElementById('add-to-cart-and-checkout');
// const productUpsell = document.querySelector('.product__upsell');

// const validateCheckbox = () => {
//   const termsCheckbox = document.getElementById('newsletter-checkbox');
//   const messageField = document.querySelector('#message');
  
//       const messageText = document.querySelector(".message_text");

//   if (!termsCheckbox || !termsCheckbox.checked) {
//     messageField.innerText = messageText.textContent;
//     messageField.style.display = 'block';
//     return false;
//   } else {
//     messageField.innerText = '';
//     messageField.style.display = 'none';
//     return true;
//   }
// };

// const addToCart = async () => {
//   try {
//     const properties = {};

//     const rokProdukcji = document.querySelector('[name="properties[Year of production]"]');
//     if (rokProdukcji) properties['Year of production'] = rokProdukcji.value;


//     const cellShape = document.querySelector('[name="properties[Cell shape]"]:checked');
//     if (cellShape) properties['Cell shape'] = cellShape.value;

//     const materialColor = document.querySelector('[name="properties[Material color]"]:checked');
//     if (materialColor) properties['Material color'] = materialColor.value;

//     const trimColor = document.querySelector('[name="properties[Trim color]"]:checked');
//     if (trimColor) properties['Trim color'] = trimColor.value;

//     const brand = document.querySelector('[name="properties[Brand]"]');
//     if (brand) properties['Brand'] = brand.value;

//     const model = document.querySelector('[name="properties[Model]"]');
//     if (model) properties['Model'] = model.value;

//     const bodyType = document.querySelector('[name="properties[Body type]"]:checked');
//     if (bodyType) properties['Body type'] = bodyType.value;

//     const orderNotes = document.querySelector('#uwagi-do-zamowienia');
//     if (orderNotes) properties['Order notes'] = orderNotes.value;


//     const productId = document.querySelector('.product-form [name="id"]').value;

//     const response = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         id: productId,
//         quantity: 1,
//         properties: properties
//       })
//     });

//     if (!response.ok) {
//       throw new Error('Ошибка при добавлении в корзину');
//     }

//     const result = await response.json();
//     console.log('Товар добавлен в корзину:', result);

//     // Перенаправление на страницу оформления заказа
//     window.location.href = '/checkout';
//   } catch (error) {
//     console.error('Ошибка при добавлении товара в корзину:', error);
//     alert('Error. Try again');
//   }
// };

// if (buyNowButton) {
//   buyNowButton.addEventListener('click', async (event) => {
//     event.preventDefault();

//     if (!validateCheckbox()) {
//       return;
//     }

//     const productFormElement = document.querySelector('product-form');
//     if (productFormElement && !productFormElement.handleErrorMessage()) {
//       return;
//     }

//     const upsellItems = productUpsell ? productUpsell.querySelectorAll('.product__upsell_item') : [];
//     for (const item of upsellItems) {
//       const input = item.querySelector('input[type="checkbox"]');
//       if (input && input.checked) {
//         const upsellId = input.value;
//         await addUpsells(upsellId);
//       }
//     }

//     await addToCart();
//   });
// }

})();
